<button
  type="button"
  class="trigger"
  cdkOverlayOrigin
  data-topbar-trigger="tenant"
  #origin="cdkOverlayOrigin"
  (click)="toggle()"
  [disabled]="!ready()"
  [attr.aria-busy]="!ready() ? true : null"
  [attr.aria-expanded]="open()"
  aria-haspopup="menu"
  data-testid="environments-btn"
>
  @if (ready()) {
    <span class="avatar">{{ initial(activeTenant()) }}</span>
    <span class="trigger-label">{{ currentLabel() }}</span>
  } @else {
    <!-- Placeholders hold the trigger's geometry so nothing reflows when the
         real tenant lands; no letter is invented for the pill. -->
    <span class="nbo-skel skel-pill"></span>
    <span class="nbo-skel skel-label"></span>
  }
  <mat-icon class="chevron" [class.dim]="!ready()">expand_more</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 6 }
  ]"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="onBackdropClick($event)"
  (detach)="onDetach()"
>
  <div class="popover" role="menu" data-testid="tenant-panel">
    @if (showSearch()) {
      <div class="search">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          [ngModel]="term()"
          (ngModelChange)="term.set($event)"
          [placeholder]="'nav.topbar.search_tenants' | translate"
          [attr.aria-label]="'nav.topbar.search_tenants' | translate"
          data-testid="tenant-search"
        />
      </div>
    }

    <!-- Current tenant is pinned, never in the scrolling list. -->
    <div class="row current" data-testid="tenant-current">
      <span class="avatar">{{ initial(activeTenant()) }}</span>
      <span class="row-label">{{ currentLabel() }}</span>
      <span class="current-tag">{{ 'nav.topbar.tenant_current' | translate }}</span>
    </div>

    @if (otherTenants().length) {
      <div class="divider"></div>
      <div class="list">
        @for (tenant of otherTenants(); track tenant.id) {
          <button type="button" class="row" role="menuitem" (click)="switchTenant(tenant)" data-testid="tenant-btn">
            <span class="avatar">{{ initial(tenant) }}</span>
            <span class="row-label">{{ label(tenant) }}</span>
          </button>
        }
      </div>
    } @else if (term()) {
      <div class="empty">{{ 'nav.topbar.no_tenants_found' | translate }}</div>
    }
  </div>
</ng-template>
